/** Pure presentational leaderboard list (top scores). */
import type { ScoreEntry } from '../services';

export function Leaderboard({ entries }: { entries: ScoreEntry[] }) {
  if (entries.length === 0) {
    return <p className="leaderboard-empty">No scores yet — be the first!</p>;
  }
  return (
    <ol className="leaderboard">
      {entries.map((e, i) => (
        <li key={`${e.uid}-${i}`} className="leaderboard-row">
          <span className="rank">{i + 1}</span>
          <span className="name">{e.name}</span>
          <span className="score">{e.score.toLocaleString()}</span>
        </li>
      ))}
    </ol>
  );
}
